export default __webpack_public_path__ + "static/media/the-sprint-team.f740146c.svg";